import { jsxs as o, jsx as e } from "react/jsx-runtime";
function a(t) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      ...t,
      children: [
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ o(
          "linearGradient",
          {
            id: "linear-gradient",
            x1: "0.5",
            x2: "0.5",
            y2: "1",
            gradientUnits: "objectBoundingBox",
            children: [
              /* @__PURE__ */ e("stop", { offset: "0", stopColor: "#b5f292" }),
              /* @__PURE__ */ e("stop", { offset: "0.962", stopColor: "#a6de85" }),
              /* @__PURE__ */ e("stop", { offset: "1", stopColor: "#ace68a" })
            ]
          }
        ) }),
        /* @__PURE__ */ o("g", { id: "Groupe_3467", "data-name": "Groupe 3467", transform: "translate(-491.43 -1137.43)", children: [
          /* @__PURE__ */ e(
            "circle",
            {
              id: "Ellipse_3010",
              "data-name": "Ellipse 3010",
              cx: "9",
              cy: "9",
              r: "9",
              transform: "translate(491.43 1137.43)",
              fill: "rgb(var(--rgb-color-green))"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              id: "Icon_awesome-bell",
              "data-name": "Icon awesome-bell",
              d: "M3.624,8.284A1.035,1.035,0,0,0,4.659,7.248H2.589A1.035,1.035,0,0,0,3.624,8.284ZM7.109,5.862a3.01,3.01,0,0,1-.9-2.5A2.555,2.555,0,0,0,4.142.855V.518a.517.517,0,1,0-1.035,0V.855a2.555,2.555,0,0,0-2.07,2.51,3.01,3.01,0,0,1-.9,2.5A.506.506,0,0,0,0,6.213a.518.518,0,0,0,.519.518h6.21a.518.518,0,0,0,.519-.518.505.505,0,0,0-.139-.351Z",
              transform: "translate(496.879 1142.288)",
              fill: "#fff"
            }
          )
        ] })
      ]
    }
  );
}
export {
  a as NotificationIcon
};
